import { useEffect } from 'react'

import useGetOrganization from '~/features/organizations/hooks/useGetOrganization'
import { store } from '~/store'

const useUpdateOrganizationStore = () => {
  const [organizationId, setOrganization] = store((state) => [
    state.user.organizationId,
    state.setOrganization,
  ])

  const {
    data: orgData,
    isSuccess,
    isLoading: isLoadingOrganization,
  } = useGetOrganization(organizationId)
  useEffect(() => {
    if (isSuccess && orgData.data) {
      setOrganization({
        paymentTier: orgData.data.paymentTier,
        referralCode: orgData.data.referralCode ?? '',
      })
    }
  }, [isSuccess, orgData, setOrganization, organizationId])

  return isLoadingOrganization
}

export default useUpdateOrganizationStore
